<template>
    <el-dialog
            title="课包下载"
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            width="500px"
            :before-close="handleClose">
        <div>
            【{{form && form.name}}】打包完成下载中{{rate}}%，请稍后...
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消下载</el-button>
          </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "package-status",
        props: {
            form: Object,
            rate: {
                type: Number,
                default: 0
            },
            visible: {
                type: Boolean,
                default: true
            },
        },
        watch:{
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){this.$emit('update:visible', vl)},
        },
        mounted() {
            // this.$nextTick(()=>{
            //     this.init()
            // })
        },
        data(){
            return {
                dialogVisible: this.visible
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false
                this.$emit('success')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
